export default "__VITE_ASSET__B6CT6HR8__"